import graphql, { getData } from 'api/graphql'

export const CREDIT_CARD_FIELDS = `
id
brand
expiryMonth
expiryYear
last4
`

const BILLING_USAGE_FIELDS = `
inbox {
  channels
  integrations
  users
  cannedReplies
  teams
  satisfactionsRatings
  rules
  customProfile
  premiumIntegrations
}
kb {
  kbs
  articles
  branding
  customScripts
  private
}
`

export const basicFields = `
  createdAt
  state
  cc_last4
  has_legacy_kb
  billing_cycle
  cancels_at
  kb {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
  }
  inbox {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
  }
  usage {
    ${BILLING_USAGE_FIELDS}
  }
  hasLastBillingFailed
`

export const EXTENDED_BILLING_FIELDS = `
  state
  cc_last4
  has_legacy_kb
  billing_cycle
  cancels_at
  kb {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
  }
  inbox {
    state
    plan
    expires_at
    has_completed_trial
    features
    quantity
    version
  }
  account {
    upcomingInvoice {
      id
      total
      nextPaymentAttempt
      amountDue
      currency
      lines {
        amount
        proration
      }
    }
    creditBalance
  }
  usage {
    ${BILLING_USAGE_FIELDS}
  }
  hasLastBillingFailed
`

const BILLING_DATA_QUERY = `
  query BillingDataQuery {
    billing {
      ${EXTENDED_BILLING_FIELDS}
    }
    plans {
      name
      product
      planId
      monthlyPrice
      annualPrice
      active
      minimumAgents
      features
    }
    creditCards {
      ${CREDIT_CARD_FIELDS}
    }
  }
`

const INVOICES_DATA_QUERY = `
query InvoicesDataQuery {
  invoices {
    id
    paid
    periodStart
    periodEnd
    number
    hostedInvoiceUrl
    invoicePdf
    total
    date
    currency
    status
    lines {
      period {
        start
        end
      }
      plan {
        id
      }
    }
  }
}
`

export const BILLING_INFORMATION_FIELDS = `
name
phone
city
country
line1
line2
postalCode
state
vatId
`

const BILLING_INFORMATION_DATA_QUERY = `
query BillingInformationDataQuery {
  billingInformation {
    ${BILLING_INFORMATION_FIELDS}
  }
}
`

export const fetchBillingData = token => {
  return graphql(token, BILLING_DATA_QUERY).then(getData)
}

export const fetchInvoices = token => {
  return graphql(token, INVOICES_DATA_QUERY).then(getData)
}

export const fetchBillingInformation = token => {
  return graphql(token, BILLING_INFORMATION_DATA_QUERY).then(getData)
}

export const billingQuery = () => `
  query BillingQuery {
    billing {
      ${basicFields}
    }
    creditCards {
      ${CREDIT_CARD_FIELDS}
    }
  }
`
